import useSWR from 'swr';
import { fetchAdBanners, AdBannerResponse } from '@/clients/customer/ad-banner';

type UseAdBannersOptions = {
  location: string;
  tagIds: number[];
  enabled?: boolean;
};

const fetcher = async (
  location: string,
  tagIds: number[]
): Promise<AdBannerResponse> => {
  return fetchAdBanners({ location, tag_ids: tagIds });
};

export default function useAdBanners({
  location,
  tagIds,
  enabled = true,
}: UseAdBannersOptions) {
  const shouldFetch = enabled && tagIds.length > 0;

  const { data, error, isLoading, mutate } = useSWR<AdBannerResponse>(
    shouldFetch ? ['ad-banners', location, tagIds] : null,
    ([, loc, ids]: [string, string, number[]]) => fetcher(loc, ids),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
}
